// ../../node_modules/@wix/image/dist/esm/Image.js
import * as React from "react";

// ../../node_modules/@wix/image/dist/esm/Image.module.scss
var Image_module_default = {};

// ../../node_modules/@wix/image/dist/esm/Image.js
import * as imageKit from "@wix/image-kit";
var { STATIC_MEDIA_URL } = imageKit;
var fetchLQIP = ({ fittingType, src, target, options }) => {
  const placeholder = imageKit.getPlaceholder(fittingType, src, target, {
    ...options,
    autoEncode: true
  });
  if (placeholder?.uri && !/^[a-z]+:/.test(placeholder.uri)) {
    placeholder.uri = `${STATIC_MEDIA_URL}${placeholder.uri}`;
  }
  return placeholder;
};
var SCHEME_RE = /^[a-z]+:/;
var Image = (props) => {
  const { id, containerId, uri, alt, name = "", role, width, height, displayMode, devicePixelRatio, quality, alignType, bgEffectName = "", focalPoint, upscaleMethod, className = "", crop, imageStyles = {}, targetWidth, targetHeight, targetScale, onLoad = () => {
  }, onError = () => {
  }, shouldUseLQIP, containerWidth, containerHeight, getPlaceholder: getPlaceholder2, isInFirstFold, placeholderTransition, socialAttrs, isSEOBot, skipMeasure, hasAnimation, encoding, isFluidLayout } = props;
  const imageRef = React.useRef(null);
  let hasSsrSrc = "";
  const hasBlurTransition = placeholderTransition === "blur";
  const ssrImageData = React.useRef(null);
  if (!ssrImageData.current) {
    if (getPlaceholder2 || shouldUseLQIP || isInFirstFold || isSEOBot) {
      const options = {
        upscaleMethod,
        ...quality ? quality : {},
        shouldLoadHQImage: isInFirstFold,
        isSEOBot,
        hasAnimation,
        encoding
      };
      ssrImageData.current = (getPlaceholder2 || fetchLQIP)({
        fittingType: displayMode,
        src: {
          id: uri,
          width,
          height,
          crop,
          name,
          focalPoint
        },
        target: {
          width: containerWidth,
          height: containerHeight,
          alignment: alignType,
          htmlTag: "img"
        },
        options
      });
      hasSsrSrc = !ssrImageData.current.transformed || isInFirstFold || isSEOBot ? "" : "true";
    } else {
      ssrImageData.current = {
        uri: void 0,
        css: { img: {} },
        attr: { img: {}, container: {} },
        transformed: false
      };
    }
  }
  const isLQIP = !isSEOBot && (getPlaceholder2 || shouldUseLQIP) && !isInFirstFold && ssrImageData.current.transformed;
  const imageInfo = React.useMemo(() => JSON.stringify({
    containerId,
    ...containerId && { containerId },
    ...alignType && { alignType },
    ...skipMeasure && { skipMeasure: true },
    displayMode,
    ...containerWidth && { targetWidth: containerWidth },
    ...containerHeight && { targetHeight: containerHeight },
    ...targetWidth && { targetWidth },
    ...targetHeight && { targetHeight },
    ...targetScale && { targetScale },
    isLQIP,
    isSEOBot,
    lqipTransition: placeholderTransition,
    encoding,
    imageData: {
      width,
      height,
      uri,
      name,
      displayMode,
      hasAnimation,
      ...quality && { quality },
      ...devicePixelRatio && { devicePixelRatio },
      ...focalPoint && { focalPoint },
      ...crop && { crop },
      ...upscaleMethod && { upscaleMethod }
    }
  }), [
    containerId,
    alignType,
    skipMeasure,
    displayMode,
    containerWidth,
    containerHeight,
    targetWidth,
    targetHeight,
    targetScale,
    isLQIP,
    isSEOBot,
    placeholderTransition,
    encoding,
    width,
    height,
    uri,
    name,
    hasAnimation,
    quality,
    devicePixelRatio,
    focalPoint,
    crop,
    upscaleMethod
  ]);
  const ssrResult = ssrImageData.current;
  const src = ssrResult?.uri;
  const srcset = ssrResult?.srcset;
  const placeholderStyle = ssrResult.css?.img;
  const classNames = `${Image_module_default.image} ${className}`;
  React.useEffect(() => {
    const imgElement = imageRef.current;
    if (onLoad && imgElement?.currentSrc && imgElement?.complete) {
      onLoad({
        target: imgElement
      });
    }
  }, []);
  const maxWidth = ssrResult && !ssrResult?.transformed ? `max(${width}px, 100%)` : targetWidth ? `${targetWidth}px` : null;
  return React.createElement(
    "wow-image",
    { id, class: classNames, "data-image-info": imageInfo, "data-motion-part": `BG_IMG ${containerId}`, "data-bg-effect-name": bgEffectName, "data-has-ssr-src": hasSsrSrc, "data-animate-blur": !isSEOBot && isLQIP && hasBlurTransition ? "" : void 0, "data-is-responsive": isFluidLayout ? "true" : void 0, style: maxWidth ? { "--wix-img-max-width": maxWidth } : {} },
    React.createElement("img", {
      src,
      ref: imageRef,
      alt: alt || "",
      role,
      style: { ...placeholderStyle, ...imageStyles },
      onLoad,
      onError,
      width: containerWidth ? containerWidth : void 0,
      height: containerHeight ? containerHeight : void 0,
      ...socialAttrs,
      srcSet: isInFirstFold ? srcset?.dpr?.map((s) => SCHEME_RE.test(s) ? s : `${STATIC_MEDIA_URL}${s}`).join(", ") : void 0,
      // @ts-expect-error fetchpriority type should work in react > 18.3 https://github.com/facebook/react/pull/25927
      fetchpriority: isInFirstFold ? "high" : void 0,
      loading: isInFirstFold === false ? "lazy" : void 0,
      // The src attribute triggers a mismatch warning because wow-image updates its src outside of the React lifecycle. This causes React to retain the old value in the virtual DOM, which could potentially lead to a bug where the old value is re-rendered during updates. However, we’re confident that this issue is not reproducing in current (16-18) React versions
      suppressHydrationWarning: true
    })
  );
};

// ../../node_modules/@wix/image/dist/esm/custom-element/utils.js
import { alignTypes, fittingTypes, getData, isWEBP, getFileExtension, fileType } from "@wix/image-kit";
var CSS_NUMERIC_VALUES = {
  columnCount: 1,
  columns: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  zIndex: 1,
  zoom: 1
};
var pick = (obj, props) => {
  const propsArr = Array.isArray(props) ? props : [props];
  return propsArr.reduce((subObj, prop) => {
    const val = obj[prop];
    return val !== void 0 ? Object.assign(subObj, { [prop]: val }) : subObj;
  }, {});
};
var addDefaultUnitIfNeeded = (prop, value) => typeof value === "number" && !CSS_NUMERIC_VALUES[prop] ? `${value}px` : value.toString();
var setStyle = (node, styleProperties) => node && styleProperties && Object.keys(styleProperties).forEach((prop) => {
  const styleProp = prop;
  const propValue = styleProperties[styleProp];
  if (propValue !== void 0) {
    node.style[styleProp] = addDefaultUnitIfNeeded(styleProp, propValue);
  } else {
    node.style.removeProperty(styleProp);
  }
});
var getScreenHeight = (heightOverride) => heightOverride || document.documentElement.clientHeight || window.innerHeight || 0;
var getImageComputedProperties = (extendedImageInfo, envConsts, htmlTag) => {
  if (!extendedImageInfo.targetWidth || !extendedImageInfo.targetHeight || !extendedImageInfo.imageData.uri) {
    return { uri: "", css: {}, transformed: false };
  }
  const { imageData } = extendedImageInfo;
  const fittingType = extendedImageInfo.displayMode || fittingTypes.SCALE_TO_FILL;
  const imageOptions = Object.assign(pick(imageData, ["upscaleMethod"]), pick(extendedImageInfo, ["filters", "encoding"]), extendedImageInfo.quality || imageData.quality, {
    hasAnimation: extendedImageInfo?.hasAnimation || imageData?.hasAnimation
  });
  const devicePixelRatioFromData = extendedImageInfo.imageData.devicePixelRatio || envConsts.devicePixelRatio;
  const devicePixelRatio = getDevicePixelRatio(devicePixelRatioFromData);
  const src = Object.assign(pick(imageData, ["width", "height", "crop", "name", "focalPoint"]), { id: imageData.uri });
  const target = {
    width: extendedImageInfo.targetWidth,
    height: extendedImageInfo.targetHeight,
    htmlTag: htmlTag || "img",
    pixelAspectRatio: devicePixelRatio,
    alignment: extendedImageInfo.alignType || alignTypes.CENTER
  };
  const imageComputedProperties = getData(fittingType, src, target, imageOptions);
  imageComputedProperties.uri = getMediaUrlByContext(imageComputedProperties.uri, envConsts.staticMediaUrl, envConsts.mediaRootUrl);
  return imageComputedProperties;
};
var getMediaUrlByContext = (imageUri, staticMediaUrl, mediaRootUrl) => {
  const isExternalUrl = /(^https?)|(^data)|(^blob)|(^\/\/)/.test(imageUri);
  if (isExternalUrl) {
    return imageUri;
  }
  let path = `${staticMediaUrl}/`;
  if (imageUri) {
    if (/^micons\//.test(imageUri)) {
      path = mediaRootUrl;
    } else if (/[^.]+$/.exec(imageUri)?.[0] === "ico") {
      path = path.replace("media", "ficons");
    }
  }
  return path + imageUri;
};
var getDevicePixelRatio = (devicePixelRatio) => {
  const queryParams = window.location.search.split("&").map((query) => query.split("="));
  const devicePixelRatioQueryParam = queryParams.find((query) => query[0]?.toLowerCase().includes("devicepixelratio"));
  const devicePixelRatioValueForceFromUrl = devicePixelRatioQueryParam?.[1] ? Number(devicePixelRatioQueryParam[1]) : null;
  return devicePixelRatioValueForceFromUrl || devicePixelRatio || 1;
};
var getImageSrc = (imageNode) => imageNode.getAttribute("src");
var imageIsAnimated = (uri, hasAnimation) => getFileExtension(uri) === fileType.GIF || getFileExtension(uri) === fileType.WEBP && hasAnimation;

// ../../node_modules/@wix/image/dist/esm/custom-element/imageLayout.js
var MOBILE_SAFE_ADDRESSBAR_HEIGHT = 80;
function getHeightOverride(height, mediaHeightOverrideType) {
  return mediaHeightOverrideType === "fixed" || mediaHeightOverrideType === "viewport" ? document.documentElement.clientHeight + MOBILE_SAFE_ADDRESSBAR_HEIGHT : height;
}
function computeScaleOverrides(imageStyle, targetScale = 1) {
  return targetScale !== 1 ? {
    ...imageStyle,
    width: "100%",
    height: "100%"
  } : imageStyle;
}
function computeStyleOverrides(mediaHeightOverrideType, imageStyle, displayMode, targetScale, isResponsive) {
  const styleWithScale = computeScaleOverrides(imageStyle, targetScale);
  if (isResponsive) {
    delete styleWithScale.height;
    styleWithScale.width = "100%";
  }
  if (!mediaHeightOverrideType) {
    return styleWithScale;
  }
  const style = { ...styleWithScale };
  if (displayMode === "fill") {
    style.position = "absolute";
    style.top = "0";
  } else if (displayMode === "fit") {
    style.height = "100%";
  }
  if (mediaHeightOverrideType === "fixed") {
    style["will-change"] = "transform";
  }
  if (style.objectPosition) {
    style.objectPosition = imageStyle.objectPosition.replace(/(center|bottom)$/, "top");
  }
  return style;
}
function getSourceSetsTargetHeightByEffect(sourceSets, offsetWidth, offsetHeight, screenHeight, services) {
  const sourceSetsTargetHeights = {};
  sourceSets.forEach(({ mediaQuery, scrollEffect }) => {
    sourceSetsTargetHeights[mediaQuery] = services.getMediaDimensionsByEffect?.(scrollEffect, offsetWidth, offsetHeight, screenHeight).height || offsetHeight;
  });
  return sourceSetsTargetHeights;
}
function computeSrcSets(measures, imageInfo, envConsts) {
  const { sourceSets } = imageInfo;
  if (!sourceSets || !sourceSets.length) {
    return;
  }
  const mediaToUri = {};
  sourceSets.forEach(({ mediaQuery, crop, focalPoint }) => {
    const imageInfoClone = {
      ...imageInfo,
      targetHeight: (measures.sourceSetsTargetHeights || {})[mediaQuery] || 0,
      imageData: {
        ...imageInfo.imageData,
        crop,
        focalPoint
      }
    };
    const imageComputedProperties = getImageComputedProperties(imageInfoClone, envConsts, "img");
    mediaToUri[mediaQuery] = imageComputedProperties.uri || "";
  });
  return mediaToUri;
}
function measure(id, measures, domNodes, { containerElm, bgEffect = "none", sourceSets }, services) {
  const innerImage = domNodes.image;
  const wixImage = domNodes[id];
  const screenHeight = getScreenHeight(services.getScreenHeightOverride?.());
  const mediaHeightOverrideType = containerElm?.dataset.mediaHeightOverrideType;
  const hasBgEffect = bgEffect && bgEffect !== "none" || sourceSets && sourceSets.some((srcset) => srcset.scrollEffect);
  const sourceOfDimensions = containerElm && hasBgEffect ? containerElm : wixImage;
  const cssBgEffect = window.getComputedStyle(wixImage).getPropertyValue("--bg-scrub-effect");
  const { width, height } = services.getMediaDimensionsByEffect?.(cssBgEffect || bgEffect, sourceOfDimensions.offsetWidth, sourceOfDimensions.offsetHeight, screenHeight) || {
    width: wixImage.offsetWidth,
    height: wixImage.offsetHeight
  };
  if (sourceSets) {
    measures.sourceSetsTargetHeights = getSourceSetsTargetHeightByEffect(sourceSets, sourceOfDimensions.offsetWidth, sourceOfDimensions.offsetHeight, screenHeight, services);
  }
  if (!innerImage) {
    return;
  }
  const imgSrc = getImageSrc(innerImage);
  if (cssBgEffect) {
    measures.top = 0.5 * (wixImage.offsetHeight - height);
    measures.left = 0.5 * (wixImage.offsetWidth - width);
  }
  measures.width = width;
  measures.height = getHeightOverride(height, mediaHeightOverrideType);
  measures.screenHeight = screenHeight;
  measures.imgSrc = imgSrc;
  measures.boundingRect = wixImage.getBoundingClientRect();
  measures.mediaHeightOverrideType = mediaHeightOverrideType;
  measures.srcset = innerImage.srcset;
}
function patch(id, measures, domNodes, imageInfo, envConsts, loadImage, isResponsive, bgEffect, loadImageImmediately) {
  if (!Object.keys(measures).length) {
    return;
  }
  const { imageData } = imageInfo;
  const wixImageNode = domNodes[id];
  const image = domNodes.image;
  if (bgEffect) {
    imageData.devicePixelRatio = 1;
  }
  const targetScale = imageInfo.targetScale || 1;
  const extendedImageInfo = {
    ...imageInfo,
    ...!imageInfo.skipMeasure && {
      targetWidth: (measures.width || 0) * targetScale,
      targetHeight: (measures.height || 0) * targetScale
    },
    displayMode: imageData.displayMode
  };
  const imageComputedProperties = getImageComputedProperties(extendedImageInfo, envConsts, "img");
  const computedStyle = imageComputedProperties?.css?.img || {};
  const imageStyle = computeStyleOverrides(measures.mediaHeightOverrideType, computedStyle, imageData.displayMode, targetScale, isResponsive);
  setStyle(image, imageStyle);
  if (measures.top || measures.left) {
    setStyle(wixImageNode, {
      top: `${measures.top}px`,
      left: `${measures.left}px`
    });
  }
  const src = imageComputedProperties?.uri || "";
  const hasAnimation = imageData?.hasAnimation || imageInfo?.hasAnimation;
  const mediaToUri = computeSrcSets(measures, extendedImageInfo, envConsts);
  if (loadImageImmediately) {
    image.dataset.ssrSrcDone = "true";
  }
  if (imageInfo.isLQIP && imageInfo.lqipTransition && !("transitioned" in wixImageNode.dataset)) {
    wixImageNode.dataset.transitioned = "";
    if (image.complete) {
      image.onload = function() {
        image.dataset.loadDone = "";
      };
    } else {
      image.onload = function() {
        if (image.complete) {
          image.dataset.loadDone = "";
        } else {
          image.onload = function() {
            image.dataset.loadDone = "";
          };
        }
      };
    }
  }
  if (loadImage) {
    if (imageIsAnimated(imageData.uri, hasAnimation)) {
      image.setAttribute("fetchpriority", "low");
      image.setAttribute("loading", "lazy");
      image.setAttribute("decoding", "async");
    } else {
      image.setAttribute("fetchpriority", "high");
    }
    image.currentSrc !== src && image.setAttribute("src", src);
    const srcIsMissingFromSrcset = measures.srcset && !measures.srcset.split(", ").some((source) => source.split(" ")[0] === src);
    if (srcIsMissingFromSrcset) {
      image.setAttribute("srcset", src);
    }
    if (domNodes.picture && extendedImageInfo.sourceSets) {
      Array.from(domNodes.picture.querySelectorAll("source")).forEach((sourceNode) => {
        const mediaQuery = sourceNode.media || "";
        const uri = mediaToUri?.[mediaQuery];
        if (sourceNode.srcset !== uri) {
          sourceNode.setAttribute("srcset", uri || "");
        }
      });
    }
  }
}
var imageLayout_default = {
  measure,
  patch
};

// ../../node_modules/@wix/image/dist/esm/custom-element/WowImage.js
var TIMEOUT = 250;
var imageEffectMap = {
  parallax: "ImageParallax",
  fixed: "ImageReveal"
};
function wowImageFactory(services, environmentConsts, contextWindow) {
  return class WowImage extends contextWindow.HTMLElement {
    constructor() {
      super();
      this.childListObserver = null;
      this.timeoutId = null;
    }
    attributeChangedCallback(_, oldValue) {
      if (oldValue) {
        this.reLayout();
      }
    }
    connectedCallback() {
      if (environmentConsts.disableImagesLazyLoading) {
        this.reLayout();
      } else {
        this.observeIntersect();
      }
    }
    disconnectedCallback() {
      this.unobserveResize();
      this.unobserveIntersect();
      this.unobserveChildren();
    }
    static get observedAttributes() {
      return ["data-image-info"];
    }
    reLayout() {
      const domNodes = {};
      const measures = {};
      const imageId = this.getAttribute("id");
      const imageInfo = JSON.parse(this.dataset.imageInfo || "");
      const isResponsive = this.dataset.isResponsive === "true";
      const { bgEffectName } = this.dataset;
      const { scrollEffect } = imageInfo.imageData;
      const { sourceSets } = imageInfo;
      const bgEffect = bgEffectName || scrollEffect && imageEffectMap[scrollEffect];
      if (sourceSets && sourceSets.length) {
        sourceSets.forEach((sourceSet) => {
          if (sourceSet.scrollEffect) {
            sourceSet.scrollEffect = imageEffectMap[sourceSet.scrollEffect];
          }
        });
      }
      domNodes[imageId] = this;
      if (imageInfo.containerId) {
        domNodes[imageInfo.containerId] = contextWindow.document.getElementById(`${imageInfo.containerId}`);
      }
      const containerElm = imageInfo.containerId ? domNodes[imageInfo.containerId] : void 0;
      domNodes.image = this.querySelector("img");
      domNodes.picture = this.querySelector("picture");
      if (!domNodes.image) {
        const target = this;
        this.observeChildren(target);
        return;
      }
      this.unobserveChildren();
      this.observeChildren(this);
      services.mutationService.measure(() => {
        imageLayout_default.measure(imageId, measures, domNodes, {
          containerElm,
          bgEffect,
          sourceSets
        }, services);
      });
      const patchImage = (shouldLoadImage, loadImageImmediately2) => {
        services.mutationService.mutate(() => {
          imageLayout_default.patch(imageId, measures, domNodes, imageInfo, environmentConsts, shouldLoadImage, isResponsive, bgEffect, loadImageImmediately2);
        });
      };
      const imageElement = domNodes.image;
      const ssrSrcNeedProcessing = this.dataset.hasSsrSrc && !imageElement.dataset.ssrSrcDone;
      const loadImageImmediately = !getImageSrc(imageElement) || ssrSrcNeedProcessing;
      if (loadImageImmediately) {
        patchImage(true, true);
      } else {
        this.debounceImageLoad(patchImage);
      }
    }
    /**
     * Debounce consecutive image loads
     *
     * @param {function} patchImage closure for patching the image
     */
    debounceImageLoad(patchImage) {
      clearTimeout(this.timeoutId);
      this.timeoutId = contextWindow.setTimeout(() => {
        patchImage(true);
      }, TIMEOUT);
      patchImage(false);
    }
    observeResize() {
      services.resizeService?.observe(this);
    }
    unobserveResize() {
      services.resizeService?.unobserve(this);
    }
    observeIntersect() {
      services.intersectionService?.observe(this);
    }
    unobserveIntersect() {
      services.intersectionService?.unobserve(this);
    }
    /**
     * Observe DOM mutations to wait for addition of missing children
     *
     * @param {HTMLElement} parent
     */
    observeChildren(parent) {
      if (!this.childListObserver) {
        this.childListObserver = new contextWindow.MutationObserver(() => {
          this.reLayout();
        });
      }
      this.childListObserver.observe(parent, { childList: true });
    }
    /**
     * Remove DOM MutationObserver if one was created
     */
    unobserveChildren() {
      if (this.childListObserver) {
        this.childListObserver.disconnect();
        this.childListObserver = null;
      }
    }
  };
}
var WowImage_default = wowImageFactory;

// ../../node_modules/@wix/image/dist/esm/custom-element/registry.js
import fastdom from "fastdom";
function init(contextWindow, services) {
  const elementName = "wow-image";
  contextWindow = contextWindow || window;
  if (contextWindow.customElements.get(elementName) === void 0) {
    let resizeObserver;
    if (contextWindow.ResizeObserver) {
      resizeObserver = new contextWindow.ResizeObserver((entries) => entries.map((entry) => entry.target.reLayout()));
    }
    let intersectionObserver;
    if (contextWindow.IntersectionObserver) {
      intersectionObserver = new IntersectionObserver((entries) => entries.map((entry) => {
        if (entry.isIntersecting) {
          const wowImage = entry.target;
          wowImage.unobserveIntersect();
          wowImage.observeResize();
        }
        return entry;
      }), {
        /**
         * old: 50% from 1080 (desktop) is 540px, 800 (mobile) 400px
         * new: 150% from 1080 (desktop) is 1620, 800 (mobile) 1200
         * chrome [loading=lazy]: 4g - 1250px, lower then 3g - 2500px
         * @see https://web.dev/articles/browser-level-image-lazy-loading#improved-thresholds
         */
        rootMargin: "150% 100%"
      });
    }
    return function(env) {
      const WowImage = WowImage_default({
        resizeService: resizeObserver,
        intersectionService: intersectionObserver,
        mutationService: fastdom,
        ...services
      }, env, contextWindow);
      contextWindow.customElements.define(elementName, WowImage);
    };
  }
  return;
}

// ../../node_modules/@wix/image/dist/esm/customElementInit.js
var getDevicePixelRatio2 = () => {
  const isMSMobileDevice = /iemobile/i.test(navigator.userAgent);
  if (isMSMobileDevice) {
    return Math.round(window.screen.availWidth / (window.screen.width || window.document.documentElement.clientWidth));
  }
  return window.devicePixelRatio;
};
var STATIC_MEDIA_URL2 = "https://static.wixstatic.com/media";
var MEDIA_ROOT_URL = "https://static.wixstatic.com";
function initCustomElement(services = {}, contextWindow = null, envConsts = {}) {
  if (typeof window === "undefined") {
    return;
  }
  const env = {
    staticMediaUrl: STATIC_MEDIA_URL2,
    mediaRootUrl: MEDIA_ROOT_URL,
    experiments: {},
    devicePixelRatio: getDevicePixelRatio2(),
    ...envConsts
  };
  const define = init(contextWindow, services);
  if (define) {
    define(env);
  }
}
export {
  Image,
  initCustomElement
};
//# sourceMappingURL=wix-image.js.map
